import ModuleShowcase from "../components/ModuleShowcase";
import ResponsiveHelper from "../utils/ResponsiveHelper";
import Swiper from "swiper/bundle";

export default class Homepage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initShowcase();
    this.initSliders();
    this.initResponsiveHelper();
  }

  initShowcase() {
    const showcaseDOMs = this.dom.querySelectorAll(".showcase-wrapper");
    if (showcaseDOMs.length > 0) {
      for (let showcaseDOM of showcaseDOMs) {
        this.showcase = new ModuleShowcase(showcaseDOM);
        this.showcase.init();
      }
    }
  }

  initSliders() {
    const heroSwiperDOM = this.dom.querySelector(".hero-slider");
    if (heroSwiperDOM != undefined) {
      let heroSwiper = new Swiper(heroSwiperDOM, {
        effect: "fade",
        autoplay: {
          delay: 4000,
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
      });
    }
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  resize() {}
}
